// Map of supported African country ISO codes to their URL names
export const africaSupportedCountryMap = {
  AO: 'angola',
  BJ: 'benin',
  BW: 'botswana',
  BF: 'burkina-faso',
  BI: 'burundi',
  CM: 'cameroon',
  CV: 'cabo-verde',
  CF: 'central-african-republic',
  TD: 'chad',
  KM: 'comoros',
  CG: 'congo',
  CI: 'cote-divoire',
  CD: 'democratic-republic-of-the-congo',
  DJ: 'djibouti',
  GQ: 'equatorial-guinea',
  ER: 'eritrea',
  ET: 'ethiopia',
  GA: 'gabon',
  GM: 'gambia',
  GH: 'ghana',
  GN: 'guinea',
  GW: 'guinea-bissau',
  KE: 'kenya',
  LS: 'lesotho',
  LR: 'liberia',
  MG: 'madagascar',
  MW: 'malawi',
  ML: 'mali',
  MR: 'mauritania',
  MU: 'mauritius',
  MZ: 'mozambique',
  NA: 'namibia',
  NE: 'niger',
  NG: 'nigeria',
  RE: 'reunion',
  RW: 'rwanda',
  ST: 'sao-tome-and-principe',
  SN: 'senegal',
  SC: 'seychelles',
  SL: 'sierra-leone',
  SO: 'somalia',
  SS: 'south-sudan',
  SZ: 'eswatini',
  TZ: 'tanzania',
  TG: 'togo',
  UG: 'uganda',
  ZA: 'south-africa',
  ZM: 'zambia',
  ZW: 'zimbabwe',
}

// Array of supported African country codes (derived from map keys)
export const africaSupportedCountryCodes = Object.keys(africaSupportedCountryMap)

// Array of URL names for all supported African countries
export const africaSupportedCountryNames = Object.values(africaSupportedCountryMap)

// Array of readable country names
export const africaCountryDisplayNames = [
  'Angola',
  'Benin',
  'Botswana',
  'Burkina Faso',
  'Burundi',
  'Cameroon',
  'Cabo Verde',
  'Central African Republic',
  'Chad',
  'Comoros',
  'Congo',
  "Côte d'Ivoire",
  'Democratic Republic Of The Congo',
  'Djibouti',
  'Equatorial Guinea',
  'Eritrea',
  'Ethiopia',
  'Gabon',
  'Gambia',
  'Ghana',
  'Guinea',
  'Guinea Bissau',
  'Kenya',
  'Lesotho',
  'Liberia',
  'Madagascar',
  'Malawi',
  'Mali',
  'Mauritania',
  'Mauritius',
  'Mozambique',
  'Namibia',
  'Niger',
  'Nigeria',
  'Reunion',
  'Rwanda',
  'Sao Tome And Principe',
  'Senegal',
  'Seychelles',
  'Sierra Leone',
  'Somalia',
  'South Sudan',
  'Eswatini',
  'Tanzania',
  'Togo',
  'Uganda',
  'South Africa',
  'Zambia',
  'Zimbabwe',
]
